/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 27.11.13, 16:19
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

/**
 * Validates the input data of the AgeGate feature.
 */
export class AgeGateValidator {
    private static MINIMUM_AGE: number = 13;

    /**
     * Validates an age or date (not finally defined yet).
     * This method is meant to be used in the web games and in the ProxyClient/Crosspromotion
     *
     * @param ageData Age of the user
     * @return true = user is old enough, false = user is too young
     */
    public static validate(ageData: number): boolean {
        return ageData >= AgeGateValidator.MINIMUM_AGE;
    }
}
